// extracted by mini-css-extract-plugin
module.exports = {"select":"MultipleStatusSelect_select__2Ta8d"};